module.exports = __webpack_public_path__ + "media/images/black_history_month/video-eb6a8cfec9b4eac7bb28486e7151bae5.png";